import { useCallback, useState } from 'react';
import StudioTopBar from './components/StudioTopBar';
import InstructionComposer from './components/InstructionComposer';
import AgentMindTimeline from './components/AgentMindTimeline';
import LiveBrowserExecutor from './components/LiveBrowserExecutor';
import RunResultModal from './components/RunResultModal';
import useAutomationNewAgent from './hooks/useAutomationNewAgent';
import styles from './styles/automationNew.module.scss';

export default function AutomationNewLayout() {
  const {
    agentUrl,
    agentHealthy,
    instructions,
    replaceInstructions,
    clearInstructions,
    variableSuggestions,
    variableDescriptions,
    fileSuggestions,
    fileDescriptions,
    refreshFiles,
    timeline,
    timelineFilter,
    timelineLength,
    setTimelineFilter,
    stats,
    runStatus,
    isRunning,
    isConnected,
    connectionError,
    latestScreenshot,
    screenshots,
    tokenUsage,
    lastResult,
    resultModalOpen,
    dismissResultModal,
    planId,
    setPlanId,
    environments,
    environmentId,
    setEnvironmentId,
    variablePayloadText,
    setVariablePayloadText,
    preflightMessages,
    runBlocked,
    variablesUsedRows,
    executorMeta,
    startRun,
    startReplay,
    stopRun,
    savePlan,
  } = useAutomationNewAgent();

  const [instructionsCollapsed, setInstructionsCollapsed] = useState(false);
  const handleInstructionsCollapsed = useCallback((collapsed) => {
    setInstructionsCollapsed(Boolean(collapsed));
  }, []);

  const canRun = instructions.some((inst) => String(inst?.text || '').trim());

  return (
    <div className={styles.page}>
      <RunResultModal
        open={resultModalOpen}
        runLabel={runStatus.label}
        result={lastResult}
        onClose={dismissResultModal}
      />
      <StudioTopBar
        runStatus={runStatus}
        isRunning={isRunning}
        isConnected={isConnected}
        agentHealthy={agentHealthy}
        connectionError={connectionError}
        agentUrl={agentUrl}
        tokenUsage={tokenUsage}
        lastResult={lastResult}
        planId={planId}
        onPlanIdChange={setPlanId}
        environments={environments}
        environmentId={environmentId}
        onEnvironmentChange={setEnvironmentId}
        variablePayloadText={variablePayloadText}
        onVariablePayloadChange={setVariablePayloadText}
        preflightMessages={preflightMessages}
        runBlocked={runBlocked}
        canRun={canRun}
        onRun={startRun}
        onReplay={startReplay}
        onStop={stopRun}
        onSavePlan={savePlan}
      />
      <div
        className={`${styles.columns} ${
          instructionsCollapsed ? styles.columnsInstructionsCollapsed : ''
        }`}
      >
        <InstructionComposer
          instructions={instructions}
          isRunning={isRunning}
          onInstructionsChange={replaceInstructions}
          onClearInstructions={clearInstructions}
          variableSuggestions={variableSuggestions}
          variableDescriptions={variableDescriptions}
          fileSuggestions={fileSuggestions}
          fileDescriptions={fileDescriptions}
          onCollapsedChange={handleInstructionsCollapsed}
          onFileUploaded={refreshFiles}
        />
        <AgentMindTimeline
          timeline={timeline}
          stats={stats}
          filter={timelineFilter}
          onFilterChange={setTimelineFilter}
          isRunning={isRunning}
          variablesUsedRows={variablesUsedRows}
          rawTimelineCount={timelineLength}
        />
        <LiveBrowserExecutor
          isRunning={isRunning}
          runLabel={runStatus.label}
          screenshot={latestScreenshot}
          screenshots={screenshots}
          meta={executorMeta}
        />
      </div>
    </div>
  );
}
